// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"638":"2f64b1d45c14403b4e2d","776":"2b9e2940c4dba4cd47b8"}[chunkId] + ".chunk.css";
};